import React, { useEffect, useMemo, useState } from "react";
import { Dropdown, Menu, Space, Modal } from "antd";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import DropShadow from "../../../../common/drop-shadow/DropShadow";
import Main from "../../../../layout/main/Main";
import {
	Filters,
	Span,
	SpanCointainer,
	CampaignsContainer,
	ActionButton,
	CardContainer,
} from "./styles";
import SignInTemplate from "../../../../layout/sign-in-template/SignInTemplate";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Typo } from "../../../../layout/theme";
import debounce from "lodash/debounce";
import { CloseCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../../utils/notificationToast";
import AntdSearch from "../../../../common/antd-search/AntdSearch";
import {
	get_initiatives,
	get_initiatives_header_info,
	update_initiative_state,
} from "../../../../../api/endpoints/initiative";
import InitiativeCardContainer from "../../../../containers/initiative-card/InitiativeCardContainer";

const { confirm } = Modal;

export default function LaboratoryInitiativeList({ clientId }) {
	const navigate = useNavigate();
	const [initiatives, setInitiatives] = useState(null);
	const [key, setKey] = useState(null);
	const [headerInfo, setHeaderInfo] = useState(null);
	const [initiativeState, setInitiativeState] = useState("ACTIVE");
	const [searchParams] = useSearchParams();
	const uri = searchParams.get("uri");

	const fetch_initiatives = async (search) => {
		const res = await get_initiatives(search, clientId, initiativeState);
		setInitiatives(res);
	};

	const fetch_initiatives_header = async () => {
		const res = await get_initiatives_header_info(clientId);
		setHeaderInfo(res);
	};

	useEffect(() => {
		fetch_initiatives("");
		fetch_initiatives_header();
	}, [initiativeState]);

	const handleInactivate = (key) => {
		confirm({
			title: "¿Seguro que quiere desactivar esta iniciativa?",
			icon: <CloseCircleOutlined style={{ color: "red" }} />,
			content: "La iniciativa se desactivara de inmediato",
			okText: "Sí",
			okType: "danger",
			cancelText: "No",
			onOk: () => {
				handleAction(key, "INACTIVE");
			},
		});
	};

	const handleActivate = (key) => {
		confirm({
			title: "¿Seguro que quiere activar esta iniciativa?",
			icon: <InfoCircleOutlined style={{ color: "blue" }} />,
			content: "La iniciativa se activara de inmediato",
			okText: "Sí",
			okType: "danger",
			cancelText: "No",
			onOk: () => {
				handleAction(key, "ACTIVE");
			},
		});
	};

	const handleDeleted = (key) => {
		confirm({
			title: "¿Seguro que quiere eliminar esta iniciativa?",
			icon: <CloseCircleOutlined style={{ color: "red" }} />,
			content: "La iniciativa se eliminara de inmediato",
			okText: "Sí",
			okType: "danger",
			cancelText: "No",
			onOk: () => {
				handleAction(key, "DELETED");
			},
		});
	};

	const handleAction = async (key, state) => {
		try {
			const _state = { id: key, state: state };
			await update_initiative_state(_state);
			fetch_initiatives("");
			fetch_initiatives_header();
			openNotificationWithIcon(
				TYPE.SUCCESS,
				"Iniciativa actualizada con exito",
				"La iniciativa se actualizo con exito"
			);
		} catch (err) {
			console.log(err);
			openNotificationWithIcon(
				TYPE.ERROR,
				"No se puedo actualizar",
				"No se puede actualizar una iniciativa cuya fecha de finalizacion es anterior a la de hoy"
			);
		}
	};

	const menuActive = (
		<Menu
			items={[
				{
					key: "1",
					label: (
						<Link to={`/admin/laboratoryInitiatives/${key}?uri=${uri}`}>
							<Typo type="secondary">Editar</Typo>
						</Link>
					),
				},
				{
					key: "2",
					label: <Typo onClick={() => handleInactivate(key)}>Desactivar</Typo>,
				},
			]}
		/>
	);

	const menuInactive = (
		<Menu
			items={[
				{
					key: "1",
					label: (
						<Link to={`/admin/laboratoryInitiatives/${key}?uri=${uri}`}>
							<Typo type="secondary">Editar</Typo>
						</Link>
					),
				},
				{
					key: "2",
					label: <Typo onClick={() => handleActivate(key)}>Activar</Typo>,
				},
				{
					key: "3",
					label: <Typo onClick={() => handleDeleted(key)}>Borrar</Typo>,
				},
			]}
		/>
	);

	const menuDeleted = (
		<Menu
			items={[
				{
					key: "1",
					label: <Typo onClick={() => handleDeleted(key)}>Borrar</Typo>,
				},
			]}
		/>
	);

	useEffect(() => {
		return () => {
			debouncedEventHandler.cancel();
		};
	}, []);

	const eventHandler = (e) => {
		fetch_initiatives(e.target.value);
	};

	const debouncedEventHandler = useMemo(() => debounce(eventHandler, 250), []);

	// if (!initiatives) return <SkeletonPublicity />;

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						{uri ? (
							<Link to={"/" + uri}>Configuración General</Link>
						) : (
							<Link to="/">Home</Link>
						)}
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>Iniciativas</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>

			<Main.Body>
				<Filters>
					<Space size="large">
						<AntdSearch
							allowClear
							enterButton={true}
							placeholder="Buscar iniciativa"
							onChange={debouncedEventHandler}
							width={400}
						/>
						<DropShadow type="drop">
							<SignInTemplate.AntdButton
								type="primary"
								bg="Primary"
								color="White"
								icon={
									<AiOutlinePlusCircle
										style={{
											top: 2,
											position: "relative",
											marginRight: "5px",
										}}
									/>
								}
								onClick={() =>
									navigate(`/admin/laboratoryInitiatives/create?uri=${uri}`)
								}
								style={{ fontWeight: "600" }}
								width={220}
								height={38}
								fontSize={12}
							>
								CREAR INICIATIVA
							</SignInTemplate.AntdButton>
						</DropShadow>
					</Space>
				</Filters>
				<SpanCointainer>
					<Span onClick={() => setInitiativeState("ACTIVE")}>
						Activas ({headerInfo?.totalActive})
					</Span>
					<Span onClick={() => setInitiativeState("FUTURE")}>
						Proximas ({headerInfo?.totalFuture})
					</Span>
					<Span onClick={() => setInitiativeState("FINISHED")}>
						Terminadas ({headerInfo?.totalFinished})
					</Span>
					<Span onClick={() => setInitiativeState("INACTIVE")}>
						Inactivas ({headerInfo?.totalInactive})
					</Span>
					<Span onClick={() => setInitiativeState("DELETED")}>
						Borradas ({headerInfo?.totalDeleted})
					</Span>
				</SpanCointainer>
				<CampaignsContainer>
					{initiatives?.map((i) => (
						<CardContainer>
							<InitiativeCardContainer item={i} />
							{initiativeState !== "DELETED" && (
								<Dropdown
									overlay={
										initiativeState === "ACTIVE"
											? menuActive
											: initiativeState === "FUTURE"
											? menuActive
											: initiativeState === "DELETED"
											? menuDeleted
											: menuInactive
									}
									placement="bottomRight"
								>
									<ActionButton onMouseOver={() => setKey(i.id)}>
										<BsThreeDotsVertical />
									</ActionButton>
								</Dropdown>
							)}
						</CardContainer>
					))}
				</CampaignsContainer>
			</Main.Body>
		</Main>
	);
}
